<dl class="grid-container vertical-gutter-lg">
    <app-portal-widget-details
        class="g-12 xs:g-6"
        heading="Kontoinhaber"
        [detail]="paymentMethod().accountHolder"
    />
    <app-portal-widget-details
        class="g-12 xs:g-6"
        heading="Bank"
        [detail]="paymentMethod().bankName"
    />
    <app-portal-widget-details
        class="g-12 xs:g-6"
        heading="IBAN"
        [detail]="paymentMethod().iban"
    />
    <app-portal-widget-details
        class="g-12 xs:g-6"
        heading="BIC"
        [detail]="bicDetail()"
    />
    @if (queued) {
        <app-portal-widget-details
            class="g-12 xs:g-6"
            heading="Gültig ab"
            [detail]="paymentMethod().validFrom | date: 'dd.MM.yyyy'"
            [isImportant]="true"
        />
        <div class="buttons g-12 md:g-6">
            <button
                class="button -blue"
                type="button"
                (click)="edit.emit()"
            >
                <i ctrlIcon="edit"></i>Anpassen
            </button>
            <button
                class="button -blue -negative"
                type="button"
                (click)="delete.emit()"
            >
                <i ctrlIcon="trash"></i>Löschen
            </button>
        </div>
    } @else {
        <app-portal-action-buttons
            class="g-12"
            confirmText="Ändern"
            rejectText="Änderung planen"
            confirmIcon="edit"
            rejectIcon="schedule"
            (clickConfirm)="edit.emit()"
            (clickReject)="add.emit()"
            [isUsedToSubmitForm]="false"
        />
    }
</dl>
